import { Activity } from "@mapmycustomers/shared/types/entity";

// Ascending = opened first, ties broken by clicked-link count.
const compareEmailEngagement = (a: Activity, b: Activity): number => {
  if (a.emailLog!.opened === b.emailLog!.opened) {
    return (a.emailLog!.linksOpened?.length ?? 0) - (b.emailLog!.linksOpened?.length ?? 0);
  }
  return a.emailLog!.opened ? -1 : 1;
};

export default compareEmailEngagement;
